const register = version => {
  window.addEventListener('load', () => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register(`/service-worker.js?${version}`)
        .then(reg => {
          console.log('serviceWorker注册成功', reg);
        })
        .catch(error => {
          console.log('serviceWorker注册失败', error);
        });
    }
  });
};

const unregister = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(function (regs) {
      for (var reg of regs) {
        reg.unregister();
      }
    });
    caches.keys().then(cacheNames => {
      cacheNames.forEach(cacheName => {
        caches.delete(cacheName);
      });
    });
  }
};

export { register, unregister };
